var map = {
	"./BuddhaAkshay/images/Logo.svg": [
		72766,
		766
	],
	"./JanBhavishya/images/Logo.svg": [
		34457,
		457
	],
	"./Suvarna/images/Logo.svg": [
		10211,
		211
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 15897;
module.exports = webpackAsyncContext;